<template>
  <div style="margin-left: 1.5rem; margin-right: 1.5rem; margin-bottom: 5rem">
    <div>
      <p style="font-size: 25px; color: #43425d; margin-top: 15px">
        {{ $t("Permission") }}
      </p>
    </div>
    <v-card class="mt-7">
      <div>
        <v-row
          class="pl-md-0 pt-9"
          style="margin-left: 15px; margin-right: 10px"
        >
          <v-col cols="12" xs="12" sm="5" md="5" lg="4">
            <v-text-field
              autocomplete="off"
              v-model="searchtxt"
              :placeholder="$t('Search')"
              color="#F99D20"
              dense
              style="margin-top: -0.3rem; margin-left: 1rem"
            ></v-text-field>
          </v-col>
          <v-btn
            color="#F99D20"
            @click="Search"
            class="white--text text-capitalize ml-5"
            width="120"
            max-height="35"
          >
            <v-icon class="pr-1">mdi-magnify</v-icon>{{ $t("Search") }}
          </v-btn>
        </v-row>
        <v-data-table
          style="margin-left: 40px; margin-right: 40px"
          :items="PermissionList"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          hide-default-header
          :headers="headers"
          @page-count="pageCount = $event"
        >
          <template v-slot:header="{ props: {} }">
            <thead>
              <tr>
                <th>
                  <!-- <label class="form-checkbox">
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @click="select"
                    />
                    <i class="form-icon"></i>
                  </label> -->
                  <v-checkbox class="custom-checkbox mt-0"
                    v-model="selectAll"
                    @click="select(selectAll)" 
                    color="#F89D1F" hide-details>
                  </v-checkbox>
                </th>
                <th>{{ $t("PermissionID") }}</th>
                <th>{{ $t("PermissionName") }}</th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <!-- <label class="form-checkbox">
                  <input
                    type="checkbox"
                    :value="{
                      perid: item.permission_ID,
                      pername: item.permission_Name,
                    }"
                    v-model="selected"
                  />
                  <i class="form-icon"></i>
                </label> -->
                <v-checkbox class="custom-checkbox mt-0" 
                    v-model="item.checked"
                    @change="checkmyemp()" 
                    color="#F89D1F" hide-details>
                </v-checkbox>
              </td>
              <td>{{ item.permission_No }}</td>
              <td>{{ item.permission_Name }}</td>
            </tr>
          </template>
        </v-data-table>

        <div class="text-right">
          <PaginationComponent
            :page.sync="page"
            :pageCount="pageCount"
            :itemsPerPage.sync="itemsPerPage"
          />
        </div>
      </div>
      <v-card-actions class="pb-6 mr-1">
        <v-spacer></v-spacer>
        <v-btn outlined class="mr-2 text-capitalize commoncancelbtn"
          text @click="Cancel">{{ $t("cancel") }}</v-btn>
        <v-btn class="mr-4 text-capitalize commonsavebtn"
          @click="SaveLocal">{{ $t("save") }}</v-btn>
      </v-card-actions>
    </v-card>
    <!-- loadingdialog -->
    <LoadingDialog :LoadingDialog="loadingdialog"></LoadingDialog>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import enurl from "@/api/environment";
import { utils } from "@/function/AuthenticatedRedirect.js";
import LoadingDialog from "@/components/Loading.vue";
import PaginationComponent from '@/components/Pagination.vue';

export default {
  components:{
    LoadingDialog,
    PaginationComponent
  },
  mixins: [utils],
  data() {
    return {
      selected: [],
      selectAll: false,
      PermissionList: [],
      loadingdialog: false,
      PermissionList1: [],
      url: enurl.apiUrl,
      page: 1,
      pageCount: 15,
      itemsPerPage: 10,
      items: [10, 20, 30],
      searchtxt: "",
      UserPer: [],
      headers: [
        {
          value: "permission_ID",
          align: "left",
          sortable: false,
        },

        {
          value: "permission_Name",
          align: "left",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    searchtxt: function () {
      if (this.PermissionList.length != this.PermissionList1.length){
        this.GetPermission();
      }
    },
    "selectAll"(){
      if(this.PermissionList1.length == this.selected.length){
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    }
  },
  async mounted() {
    this.GetPermission();
    this.GetUserPerByEmpID();
    let id = localStorage.getItem("empcode");
    if (id != null) {
      await this.ChangeCodeToID();
    }
    // this.GetUserRoleByEmpID();
  },
  methods: {
    async ChangeCodeToID() {
      let self = this;
      let Id = localStorage.getItem("empcode");
      let temp = {
        employee_Code: Id,
        company_ID: store.state.companyID,
      };
      const response = await axios.post(
        `${self.url}PersonalInfo/GetPersonalInformationWithCode`,
        temp
      );
      let empId = response.data.data.employee_ID;
      return empId;
    },
    Search() {
      let self = this;
      if (self.searchtxt != "" && self.searchtxt != undefined) {
        let List = self.PermissionList;
        self.PermissionList = [];
        let temp = self.PermissionList1.filter(
          (v) =>
            v.permission_No
              .toLowerCase()
              .indexOf(self.searchtxt.toLowerCase()) > -1 ||
            v.permission_Name
              .toLowerCase()
              .indexOf(self.searchtxt.toLowerCase()) > -1
        );
        let empListMap = new Map();
        self.PermissionList = temp;
        temp.forEach(item => {
          empListMap.set(item.permission_ID, item);
        });
        List.forEach(item => {
          if (item.checked) {
            empListMap.set(item.permission_ID, item);
          }
        });
        self.PermissionList = Array.from(empListMap.values());
      } else {
        alert("Please enter text");
        self.GetPermission();
      }
    },
    GetIndex(val) {
      let self = this;
      let data = self.PermissionList.indexOf(val);
      data++;
      return data;
    },
    Cancel() {
      let self = this;
      self.uid = parseInt(self.$route.params.id);
      // self.$router.push({ name: "EditAccount", params: { id: self.uid } });
      if (self.$route.params.id != null) {
        self.$router.push(
          `/PersonnelManagement/EditEmployee/${self.uid}/EditPersonalInformation/Account`
        ).catch(()=>{});
      } else if (self.$route.name == "NPermission") {
        self.$router.push(
          "/PersonnelManagement/NewEmployee/NewPersonalInformation/Account"
        ).catch(()=>{});
        // localStorage.setItem("UserEditPer", null);
      }
    },
    SaveLocal() {
      let self = this;
      self.uid = parseInt(self.$route.params.id);
      localStorage.setItem("UserEditPer", JSON.stringify(self.selected));
      if (self.$route.params.id != null) {
        self.$router.push(
          `/PersonnelManagement/EditEmployee/${self.uid}/EditPersonalInformation/Account`
        ).catch(()=>{});
      } else if (self.$route.name == "NPermission") {
        self.$router.push(
          "/PersonnelManagement/NewEmployee/NewPersonalInformation/Account"
        ).catch(()=>{});
      }
    },
    select(value) {
      this.PermissionList = this.PermissionList.map((v) => ({
        ...v,
        checked: value,
      }));
      this.selected = 
      this.PermissionList
      .filter(user => user.checked)
      .map((v) => {
        return {
          perid: v.permission_ID,
          pername: v.permission_Name,
        };
      });
    },
    checkmyemp() {
      let checkvalidate = this.PermissionList.filter((data) => data.checked == true);

      let checkfalsevalidate = this.PermissionList.filter((date) => date.checked == false);
      if (checkfalsevalidate.length != 0) {
        this.selectAll = false;
      }

      if (checkvalidate.length != 0) {
        if (checkvalidate.length == this.PermissionList.length) {
          this.selectAll = true;
        }
      }
      this.selected = 
      this.PermissionList
      .filter(user => user.checked)
      .map((v) => {
        return {
          perid: v.permission_ID,
          pername: v.permission_Name,
        };
      });
    },
    GetPermission() {
      let self = this;
      //self.loadingdialog = true;
      axios
        .get(`${self.url}Permission/GetPermission`)
        .then(function (response) {
          let llist = response.data.data;
          self.PermissionList = llist.map((v) => ({
                ...v,
                checked: false,
              }));
          if(self.selected.length != 0){
            self.PermissionList = llist.map((v) => ({
              ...v,
              checked: self.selected.some((user) => user.perid === v.permission_ID),
            }));
          }
          self.PermissionList1 = self.PermissionList;
          //self.loadingdialog = false;
        });
    },
    async GetUserPerByEmpID() {
      let self = this;
      self.loadingdialog = true;
      let id = null;
      if (self.$route.params.id == null || self.$route.params.id == undefined) {
        id = await self.ChangeCodeToID();
      }
      let tempp=null;
      if (self.$route.params.id != null) {
        tempp = {
          employee_ID: parseInt(self.$route.params.id),
          company_ID: store.state.companyID,
        };
      }
      else if (self.$route.params.id == undefined) {
        tempp = {
          employee_ID: id,
          company_ID: store.state.companyID,
        };
      }
      axios
        .post(`${self.url}UserGroupMember/GetUserPermission`, tempp)
        .then(function (response) {
          self.UserPer = response.data.data;
          if(localStorage.getItem("UserEditPer") === null && self.UserPer.length === 0){
            self.loadingdialog = false;
          } else if(localStorage.getItem("UserEditPer") === "null" && self.UserPer.length === 0){
            self.loadingdialog = false;
          } else if(localStorage.getItem("UserEditPer") !== null &&
                    localStorage.getItem("UserEditPer") !== "null" && self.UserPer.length === 0){
            for(let i = 0; i< JSON.parse(localStorage.getItem("UserEditPer")).length; i++)
            {
              self.selected.push(JSON.parse(localStorage.getItem("UserEditPer"))[i]) 
            }
            self.PermissionList = self.PermissionList.map((v) => ({
              ...v,
              checked: self.selected.some((user) => user.perid === v.permission_ID),
            }));
            self.loadingdialog = false;
          } else if(localStorage.getItem("UserEditPer") !== null &&
                    localStorage.getItem("UserEditPer") !== "null" && self.UserPer.length !== 0){
            for(let i = 0; i< JSON.parse(localStorage.getItem("UserEditPer")).length; i++)
            {
              self.selected.push(JSON.parse(localStorage.getItem("UserEditPer"))[i]) 
            }
            self.PermissionList = self.PermissionList.map((v) => ({
              ...v,
              checked: self.selected.some((user) => user.perid === v.permission_ID),
            }));
            self.loadingdialog = false;
          } else if(localStorage.getItem("UserEditPer") === null ||
                    localStorage.getItem("UserEditPer") === "null" && self.UserPer.length !== 0) {
            for (let i = 0; i < self.UserPer.length; i++) {
              self.selected.push({
                perid: self.UserPer[i].permission_ID,
                pername: self.UserPer[i].permission_Name,
              });
            }
            self.PermissionList = self.PermissionList.map((v) => ({
              ...v,
              checked: self.selected.some((user) => user.perid === v.permission_ID),
            }));
            self.loadingdialog = false;
          }
          self.loadingdialog = false;
        });
    },
  },
};
</script>
  <style scoped>
>>> .theme--light.v-pagination .v-pagination__item {
  background: #fff !important;
  color: rgba(0, 0, 0, 0.87);
}
>>> .theme--light.v-pagination .v-pagination__item--active {
  background: #f99d20 !important;
  color: white !important;
}
>>> .v-data-table__mobile-row__header {
  font-weight: unset !important;
  color: #f99d20 !important;
}
>>> .theme--light.v-data-table thead tr th {
  color: #f99d20 !important;
}
>>> .theme--light.v-data-table thead tr th {
  color: #f99d20;
  font-size: 17px;
  font-weight: 300;
}
>>> .theme--light.v-data-table
  tbody
  tr:not(:last-child)
  td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  tbody
  tr:not(:last-child)
  th:not(.v-data-table__mobile-row) {
  border: unset;
}
>>> tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>